/**
 * Tiny external store for the global HelpPanel open state (OPSFL-HELP-1). The panel is mounted
 * ONCE in the app shell; the `?` hotkey and HelpMenu's "About this page" open it from anywhere
 * without context threading or a new dependency.
 */
import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function openHelpPanel(): void {
  if (!open) {
    open = true;
    emit();
  }
}

export function closeHelpPanel(): void {
  if (open) {
    open = false;
    emit();
  }
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useHelpPanelOpen(): boolean {
  return useSyncExternalStore(subscribe, () => open);
}
